import React, { FC } from "react";
import styled from "styled-components";
import { product_shop_collections_products_collections } from "../../__generated__/product";

interface IIconTags {
  collections: product_shop_collections_products_collections[];
  small?: boolean;
  discount?: boolean;
}
const IconTags: FC<IIconTags> = ({ collections, small, discount }) => {
  const isSpicy = !!collections.find(
    (collection) => collection.slug === "spicy"
  );
  const isNew = !!collections.find((collection) => collection.slug === "new");
  const isPopular = !!collections.find(
    (collection) => collection.slug === "popular"
  );

  return (
    <IconTagWrap>
      {isSpicy && (
        <IconTag
          small={small}
          src="../../static/icons/spicy.svg"
          alt="острое"
        />
      )}
      {isNew && (
        <IconTag small={small} src="../../static/icons/new.svg" alt="новинки" />
      )}
      {isPopular && (
        <IconTag
          small={small}
          src="../../static/icons/hit.svg"
          alt="хиты продаж"
        />
      )}
      {discount && (
        <IconTag small={small} src="../../static/icons/sale.svg" alt="акции" />
      )}
    </IconTagWrap>
  );
};

const IconTagWrap = styled.div`
  z-index: 1;
  position: absolute;
  left: 20px;
  top: 20px;
`;

interface IIconTag {
  small?: boolean;
}
const IconTag = styled.img<IIconTag>`
  display: block;
  margin-bottom: 10px;
  width: ${({ small }) => (small ? "50px" : "70px")};
  height: ${({ small }) => (small ? "50px" : "70px")};
  border-radius: 50px;

  @media (max-width: 550px) {
    width: 40px;
    height: 40px;
    left: 15px;
  }

  img {
    position: absolute;
    right: 22px;
    top: 22px;

    @media (max-width: 550px) {
      width: 20px;
      right: 10px;
      top: 10px;
    }
  }
`;

export default IconTags;
